/**
=========================================================
 

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { FaTasks } from "react-icons/fa";
import { GiReceiveMoney } from "react-icons/gi";
import { TbMoneybag, TbProgressCheck } from "react-icons/tb";
import { CiBank } from "react-icons/ci";
import { IoShareSocial, IoWalletSharp } from "react-icons/io5";
import { PiHandWithdrawFill } from "react-icons/pi";
import { TbProgressAlert } from "react-icons/tb";

const inconTypes = (iconType) => {
  if (iconType === "FaTasks") {
    return <FaTasks />;
  } else if (iconType === "GiReceiveMoney") {
    return <GiReceiveMoney size={30} />;
  } else if (iconType === "TbMoneybag") {
    return <TbMoneybag size={30} />;
  } else if (iconType === "CiBank") {
    return <CiBank size={30} />;
  } else if (iconType === "IoShareSocial") {
    return <IoShareSocial size={30} />;
  } else if (iconType === "PiHandWithdrawFill") {
    return <PiHandWithdrawFill size={30} />;
  } else if (iconType === "TbProgressAlert") {
    return <TbProgressAlert size={30} />;
  } else if (iconType === "TbProgressCheck") {
    return <TbProgressCheck size={30} />;
  } else if (iconType === "IoWalletSharp") {
    return <IoWalletSharp size={30} />;
  }
};
function ComplexStatisticsCard({ color, title, count, percentage, icon, iconType }) {
  return (
    <Card>
      <MDBox display="flex" justifyContent="space-between" pt={1} px={2}>
        <MDBox
          variant="gradient"
          bgColor={color}
          color={color === "light" ? "dark" : "white"}
          coloredShadow={color}
          borderRadius="xl"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="4rem"
          height="4rem"
          mt={-3}
        >
          {inconTypes(iconType)}
        </MDBox>
        <MDBox textAlign="right" lineHeight={1.25}>
          <MDTypography variant="button" fontWeight="light" color="text">
            {title}
          </MDTypography>
          <MDTypography variant="h4">{count}</MDTypography>
        </MDBox>
      </MDBox>
      <Divider />
      <MDBox pb={2} px={2}>
        <MDTypography component="p" variant="button" color="text" display="flex">
          <MDTypography
            component="span"
            variant="button"
            fontWeight="bold"
            color={percentage.color}
          >
            {percentage.amount}
          </MDTypography>
          &nbsp;{percentage.label}
        </MDTypography>
      </MDBox>
    </Card>
  );
}

// Setting default values for the props of ComplexStatisticsCard
ComplexStatisticsCard.defaultProps = {
  color: "info",
  percentage: {
    color: "success",
    text: "",
    label: "",
  },
};

// Typechecking props for the ComplexStatisticsCard
ComplexStatisticsCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  iconType: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  percentage: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "white",
    ]),
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  icon: PropTypes.node.isRequired,
};

export default ComplexStatisticsCard;
